import { Injectable } from '@angular/core';
import { of, Observable, concat } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../profile/services/base.service';
import { SupplierDocument } from '../../profile/models/supplier.model';
import { AppSettings } from '../../app.settings';

@Injectable()
export class FileUploadService extends BaseService {
    documentTabFiles: File[];
    constructor(private http: HttpClient, private config: AppSettings) {
        super();
        this.documentTabFiles = [];
    }

    uploadFileToServer(files: File[], supplierCode: string, additionalFormData: { [key: string]: string } = {}): Observable<any> {
        if (files.length <= 0) { return; }

        const formData = new FormData();
        files.map(file => {
            formData.append('files', file, file.name);
        });
        formData.append('supplierCode', supplierCode);

        //  Append additional form data
        for (let key in additionalFormData) {
            formData.append(key, additionalFormData[key]);
        }

        return this.http.post(`${this.config.BaseUrl}Profile/UploadDocument`, formData, { headers: this.setFileHeaders() });
    }

    uploadFiles(attachments: SupplierDocument[], supplierCode: string): Observable<SupplierDocument[]> {
        if (attachments && attachments.length > 0) {
            const files: File[] = attachments
                .map(attachment => {
                    if (attachment.Attachment instanceof File) { return attachment.Attachment; }
                });

            if (files.length > 0 && files[0]) {
                return this.uploadFileToServer(files, supplierCode)
                    .pipe(
                        map(file => {
                            return attachments.map(att => {
                                att.FileName = file.fileName;
                                att.DocumentID = file.documentID;
                                att.DocumentVersion = file.documentVersion;
                                return att;
                            })
                        })
                    )
            }
            else {
                return of(attachments);
            }
        }
        return of([]);
    }

    uploadFilesToServer(files: File[], supplierCode: string, additionalFormData: { [key: string]: string } = {}): Observable<any[]> {
        if (files.length <= 0) { return; }

        const formData = new FormData();
        files.map(file => {
            formData.append('files', file, file.name);
        });
        formData.append('supplierCode', supplierCode);

        //  Append additional form data
        for (let key in additionalFormData) {
            formData.append(key, additionalFormData[key]);
        }

        return this.http.post<any[]>(`${this.config.BaseUrl}Profile/UploadDocuments`, formData, { headers: this.setFileHeaders() });
    }
}
